module.exports = __webpack_public_path__ + "static/media/Snowflake.fba0d20b.png";